import { FormikErrors, FormikTouched } from 'formik';

function validationProps<T>(accessor: keyof T, errors: FormikErrors<T>, touched: FormikTouched<T>) {
	if (!touched[accessor]) return { name: accessor };

	return {
		name: accessor,
		error: !!errors[accessor],
		helperText: errors[accessor],
	};
}

export default validationProps;
